import React, { memo } from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import classNames from 'classnames'
import { AgroservicesCardPrice } from '@/components/resolvers/AgroServices/components/AgroservicesCardPrice'
import { Button, Image } from '@/components/ui'
import { useWebpExtension } from '@/utils/hooks/image'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { getStaticImagePath } from '@/utils/images'
import type { IAgroserviceGeneralCardProps } from './types'
import './styles.scss'

const AgroserviceGeneralCard: React.FC<IAgroserviceGeneralCardProps> = props => {
  const { productId, url, logo, onClick, className, mainActionText, title, description, oldPrice, price, paymentPeriod } = props

  const { isMobile } = useDeviceType()

  const imageExtension = useWebpExtension()

  return (
    <div
      className={classNames('agroserviceGeneralCard agroservice-card-wrapper', className)}
      style={{ backgroundImage: `url("${getStaticImagePath(`index/agroServices/${productId}.${imageExtension}`)}")` }}
    >
      <section className={classNames('agroservice-card-item-wrapper agroserviceGeneralCard__item')}>
        {logo && !isMobile && <Image className="agroserviceGeneralCard__logo" src={`logos/${logo}.${imageExtension}`} isInStatic />}

        <div className="agroserviceGeneralCard__content with-blurred-bottom-block with-blurred-bottom-block_visible">
          {logo && isMobile && (
            <div className="agroserviceGeneralCard__logoInsideContent">
              <Image src={`logos/${logo}.${imageExtension}`} isInStatic />
            </div>
          )}
          <div className="agroserviceGeneralCard__text">
            <h4 className="agroserviceGeneralCard__title">{title}</h4>
            {description && <div className="agroserviceGeneralCard__description">{description}</div>}
          </div>

          <div className="agroserviceGeneralCard__bottomLine">
            {mainActionText && (
              <CommonLink className="agroserviceGeneralCard__button" url={url}>
                <Button onClick={onClick} modifiers={['white']}>
                  {mainActionText}
                </Button>
              </CommonLink>
            )}

            {price && <AgroservicesCardPrice price={price} oldPrice={oldPrice} paymentPeriod={paymentPeriod} />}
          </div>
        </div>
      </section>
    </div>
  )
}

export default memo(AgroserviceGeneralCard)
